import React, { useContext } from 'react';

import '../styles/badge.css';

const Badge = ({ content = "", className = "" }) => {
    return content ? (
        <div className={ `notification-badge ${ className }` }>
            { content }
        </div>
    ) : null;
};

export default Badge;
